module.exports = __webpack_public_path__ + "img/imgcreatividad1.8d4833ec.png";